import request from '@/utils/request'
import API from '@/api/index.js'

/**
 * 问卷列表
 * @param pageSize
 * @param current
 * @returns {*}
 */
export function dwSurveyList (pageSize, current, surveyName, surveyState) {
  const params = {
    pageSize,
    current,
    surveyName,
    surveyState
  }
  return request({
    url: API.surveyList,
    method: 'get',
    params
  })
}
/**
 * 创建问卷
 * @param data
 * @returns {*}
 */
export function dwSurveyCreate (data) {
  return request({
    url: API.surveyCreate,
    method: 'post',
    data
  })
}

/**
 * 更新问卷状态
 * @param surveyId
 * @param surveyState
 * @returns {*}
 */
export function dwSurveyUpState (surveyId, surveyState) {
  const params = {
    surveyId,
    surveyState
  }
  return request({
    url: API.surveyUpState,
    method: 'post',
    params
  })
}
/**
 * 复制问卷
 * @param data
 * @returns {*}
 */
export function dwSurveyCopy (fromSurveyId, surveyName) {
  const params = {
    fromSurveyId,
    surveyName,
    tag: '2'
  }
  return request({
    url: API.surveyCopy,
    method: 'post',
    params
  })
}
/**
 * 获取问卷信息
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyInfo (surveyId, startTime, endTime) {
  const params = {
    id: surveyId,
    startTime,
    endTime
  }
  return request({
    url: API.surveyInfo,
    method: 'get',
    params
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyUpdate (data) {
  return request({
    url: API.surveyUpdate,
    method: 'put',
    data
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyDelete (data) {
  return request({
    url: API.surveyDelete,
    method: 'delete',
    data
  })
}
/**
 * 导出管理列表
 * @param surveyId
 * @param surveyState
 * @returns {*}
 */
export function surveyAnswerExportList (pageSize, current) {
  const params = {
    pageSize,
    current
  }
  return request({
    url: API.surveyAnswerExportList,
    method: 'get',
    params
  })
}
/**
 * 导出管理删除
 * @param surveyId
 * @param surveyState
 * @returns {*}
 */
export function surveyAnswerExportDelete (id) {
  const params = {
    id
  }
  return request({
    url: API.surveyAnswerExportDelete,
    method: 'get',
    params
  })
}
/**
 * 未提交名单
 * @param surveyId
 * @param surveyState
 * @returns {*}
 */
export function surveyAnswerUnSubmit (surveyId, startTime, endTime, planId, pageSize, current) {
  const params = {
    surveyId,
    startTime,
    endTime,
    planId,
    pageSize,
    current
  }
  return request({
    url: API.surveyAnswerUnSubmit,
    method: 'get',
    params
  })
}
// 实习学年下拉
export function getBatchAll (data) {
  return request({
    url: '/practice/batch/v1/list',
    method: 'post',
    data
  })
}
export function getPlanByTea (data) {
  data.isWeb = 0
  return request({
    url: '/practice/plan/v1/getPlanByTea',
    method: 'post',
    data
  })
}
/**
 * 获取问卷的统计信息
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyReport (surveyId, startTime, endTime) {
  const params = {
    surveyId,
    startTime,
    endTime
  }
  return request({
    url: API.surveyReport,
    method: 'get',
    params
  })
}
/**
 * 获取问卷的答卷列表
 * @param pageSize
 * @param current
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyAnswerList (pageSize, current, surveyId, startTime, endTime) {
  const params = {
    pageSize,
    current,
    surveyId,
    startTime,
    endTime
  }
  return request({
    url: API.surveyAnswerList,
    method: 'get',
    params
  })
}
/**
 * 获取问卷的答卷列表
 * @param pageSize
 * @param current
 * @param surveyId
 * @returns {*}
 */
export function dwSurveyAnswerExport (surveyId, expUpQu, startTime, endTime) {
  const params = {
    surveyId,
    expUpQu,
    startTime,
    endTime
  }
  return request({
    url: API.surveyAnswerExport,
    method: 'get',
    params
  })
}
/**
 * 更新问卷信息
 * @param data
 * @returns {*}
 */
export function dwSurveyAnswerDelete (data) {
  return request({
    url: API.surveyAnswerDelete,
    method: 'delete',
    data
  })
}
/**
 * 获取问卷答卷详情
 * @param answerId
 * @returns {*}
 */
export function dwSurveyAnswerInfo (answerId) {
  const params = {
    answerId
  }
  return request({
    url: API.surveyAnswerInfo,
    method: 'get',
    params
  })
}

export function dwSurveyUnSubmitExport (surveyId, startTime, endTime, planId) {
  const params = {
    surveyId,
    startTime,
    endTime,
    planId
  }
  return request({
    url: API.dwSurveyUnSubmitExport,
    method: 'get',
    params
  })
}




// WEBPACK FOOTER //
// ./src/api/dw-survey.js